import { Navigate } from "react-router-dom";
import { Loader } from "@themes/pollinator/ui/Loader";
import { useFetchActions } from "@core/features/actions";
import { usePlatformStore } from "@platform/store";

/**
 * Where /support leads: the dashboard's own Support, the help center inside
 * the member's program.
 *
 * The address is reached from the footer, which every page has, signed in or
 * not. It sits behind sign-in, so somebody signed out signs in first and is
 * then brought here, and on to the help center. The program is the one the
 * dashboard's Support item opens, the program of the member's first action;
 * somebody in no program yet has no help center, and goes to the dashboard.
 */
export function SupportRedirectPage() {
  const user = usePlatformStore((s) => s.user);
  const { data, isLoading } = useFetchActions({ user, isEnabled: !!user });

  if (isLoading) return <Loader isFullPage />;

  const programId = data?.actions?.[0]?.program;
  return (
    <Navigate to={programId ? `/program/${programId}/support` : "/dashboard"} replace />
  );
}

export default SupportRedirectPage;
